import React, { useState } from 'react';
import { IconNames, Icon, ToastMessages, MessagePosition, MessageType} from '@triumph/design-system';
import { ToastMessageProps } from '@triumph/design-system/components/ToastMessages/ToastMessage/ToastMessage.types';
import { ClipboardCopyButton } from './ClipboardCopyButton.StyledComponents';
import { useAppContext } from '@/app/components/providers/AppContextProvider';

interface CopyToClipboardButtonProps {
    value: string;
    displayText?: string | null;
}

export const CopyToClipboardButton: React.FC<CopyToClipboardButtonProps> = ({
    value,
    displayText
}) => {
  const [showMessage, setShowMessage] = useState(false);
    const messages: ToastMessageProps[] = [{
      handleClose: () => reset(),
      type: MessageType.success,
      message: 'Copied!',
      show: showMessage,
      messageId: 1,
      toastTestId: 'simple_bottomLeft',
      autoCloseTime: 1000
    }];

    const reset = () => {
      setShowMessage(false);
    };

    const handleCopy = async () => {
      await navigator.clipboard.writeText(value);
      setShowMessage(true);
  };
    
  const { theme } = useAppContext();
  
  return (
    <div >
      {displayText ?? value }
        <ClipboardCopyButton onClick={handleCopy}>
            <Icon
                id="copy-link-icon"
                size={"sm"} 
                color={`${theme.colors.link.default}`                        
}
                name={IconNames.Interface_LinkDefault}
            />
        </ClipboardCopyButton>
        <ToastMessages messages={messages} position={MessagePosition.bottomLeft} />
    </div>
  );
}